/**
 * @generated SignedSource<<7aff3491a15626bbbe66052137ff445e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveInstallmentCompleted_charge$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompleted_charge">;
  readonly " $fragmentType": "PaymentActiveInstallmentCompleted_charge";
};
export type PaymentActiveInstallmentCompleted_charge$key = {
  readonly " $data"?: PaymentActiveInstallmentCompleted_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallmentCompleted_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveInstallmentCompleted_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "bf80d1880afdeab33fa7f5f91700d9d8";

export default node;
